import React from "react";
import { Card } from "react-bootstrap";
import { FaFacebook, FaInstagram, FaGlobe } from "react-icons/fa";

const CARD_META = [
  { key: "insta",   platform: "Instagram", icon: FaInstagram, color: "#C13584", bg: "#fdf2f8" },
  { key: "fb",      platform: "Facebook",  icon: FaFacebook,  color: "#1877F2", bg: "#eff6ff" },
  { key: "website", platform: "Website",   icon: FaGlobe,     color: "#6b7280", bg: "#f3f4f6" },
];

const SocialStats = ({ stats }) => {
  if (!stats) return null;

  return (
    <Card
      className="mt-3"
      style={{ border: "none", borderRadius: "16px", boxShadow: "0 1px 3px rgba(0,0,0,0.08), 0 4px 16px rgba(0,0,0,0.06)", overflow: "hidden" }}
    >
      <Card.Body style={{ padding: "20px 24px" }}>
        <div style={{ fontSize: "11px", fontWeight: 700, color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: "14px" }}>
          Social
        </div>
        <div style={{ display: "flex", gap: "10px" }}>
          {CARD_META.map(({ key, platform, icon: Icon, color, bg }) => (
            <div
              key={key}
              style={{ flex: 1, background: "#fafafa", border: "1px solid #f0f0f0", borderRadius: "12px", padding: "14px 16px" }}
            >
              <div style={{ width: 32, height: 32, borderRadius: "8px", background: bg, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "10px" }}>
                <Icon size={16} color={color} />
              </div>
              <div style={{ fontSize: "22px", fontWeight: 700, color: "#111827", lineHeight: 1 }}>
                {stats[key] ?? 0}
              </div>
              <div style={{ fontSize: "11px", color: "#9ca3af", marginTop: "5px", fontWeight: 500 }}>
                {platform}
              </div>
            </div>
          ))}
        </div>
      </Card.Body>
    </Card>
  );
};

export default SocialStats;
